// extracted by mini-css-extract-plugin
export default {"tooltip":"_16MVD4tByCYcjif0zYebm5"};